import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//images/login_logo.svg'
import _imports_1 from '../assets/images/login_under.svg'


const _withScopeId = n => (_pushScopeId("data-v-74f2fae9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity_wrapper" }, null, -1))
const _hoisted_4 = { class: "form_container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_text_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "head_text" }, "고객 접수용")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    calss: "img_logo",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "section1_text" }, "조이웍스 A/S 온라인 신청서")
], -1))
const _hoisted_7 = { class: "section2" }
const _hoisted_8 = { class: "input_wrap" }
const _hoisted_9 = { class: "input_wrap" }
const _hoisted_10 = ["readonly"]
const _hoisted_11 = { class: "timeStamp" }
const _hoisted_12 = {
  key: 0,
  class: "input_wrap"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_text" }, "인증번호 시간이 초과 되었습니다.", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

import router from "@/router";
import { useStore } from "vuex";
import authAPI from "@/api/authAPI";
import { ref } from "vue";
import { phoneNumberChk } from "@/common/common";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientLogin',
  setup(__props) {

const store = useStore();
const focus: any = ref(null);
const param = ref({
  login_id: "",
  password: "",
});
const time: any = ref({
  mm: 3,
  ss: "00",
  chktime: 180,
});
const chk = ref(true);
let timeover = false;

let interval: any = null;
const reset = () => {
  clearInterval(interval);
  timeover = false;
  param.value.password = "";
  time.value = {
    mm: 3,
    ss: "00",
    chktime: 180,
  };
};
const takeTarget = () => {
  focus.value.focus();
  interval = setInterval(function () {
    if (time.value.chktime > 0) {
      // >= 0 으로하면 -1까지 출력된다.
      time.value.chktime = time.value.chktime - 1; // 여기서 빼줘야 3분에서 3분 또 출력되지 않고, 바로 2분 59초로 넘어간다.
      let min = Math.floor(time.value.chktime / 60);
      let sec = String(time.value.chktime % 60).padStart(2, "0");
      time.value.mm = min;
      time.value.ss = sec;
      if (time.value.mm == 0 && time.value.ss == 0) {
        timeover = true;
      }
      // time = time - 1
    } else {
      timeover = true;
    }
  }, 1000);
};
const sendSMS = () => {
  reset();
  if (phoneNumberChk(param.value.login_id)) {
    authAPI.smsAuth(param.value).then(() => {
      chk.value = false;
      takeTarget();
    });
  } else {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "휴대폰번호를 확인하세요.",
    });
    return;
  }
};
const login = () => {
  if (!timeover) {
    authAPI.login(param.value).then((res: any) => {
      if (res.data.status != 200) {
        window.customAlert({
          title: "A/S 고객접수",
          msg: "인증번호를 확인하세요.",
        });
        return;
      }
      store.commit("setUserInfo", res.data.data);
      router.push({
        name: "clientHome",
      });
    });
  } else {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "인증번호 시간이 초과 되었습니다. <br>재전송 해주세요.",
      sCb: function () {
        param.value.password = "";
      },
    });
    return;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "전화번호를 입력해 주세요.",
            class: _normalizeClass(["input_text", { input_text2: !chk.value }]),
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((param.value.login_id) = $event)),
            onKeyup: _withKeys(sendSMS, ["enter"])
          }, null, 34), [
            [_vModelText, param.value.login_id]
          ]),
          (chk.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "input_button",
                onClick: sendSMS
              }, "인증"))
            : _createCommentVNode("", true),
          (!chk.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "input_button",
                onClick: sendSMS
              }, "재전송"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "인증번호를 입력 해주세요.",
            class: _normalizeClass({ input_text: !chk.value, input_text2: chk.value }),
            type: "text",
            ref_key: "focus",
            ref: focus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((param.value.password) = $event)),
            onKeyup: _withKeys(login, ["enter"]),
            readonly: chk.value
          }, null, 42, _hoisted_10), [
            [_vModelText, param.value.password]
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(time.value.mm) + ":" + _toDisplayString(time.value.ss), 1)
        ]),
        (_unref(timeover))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "section3" }, [
        _createElementVNode("div", {
          onClick: login,
          class: "login_button"
        }, "로그인")
      ]),
      _hoisted_15
    ])
  ]))
}
}

})